import {
  Modal as BaseModal,
  CustomModal as BaseCustomModal,
} from '../../baseComponents';
import { withReduxState } from './ModalWithRedux';

export const Modal = withReduxState(BaseModal);
export const CustomModal = withReduxState(BaseCustomModal);
